export enum InputDateFormat {
  DayMonthYear = "DD.MM.YYYY",
  MonthDayYear = "MM.DD.YYYY",
}
